import { LogoCloudCarousel } from "../../../../modules/content/components/LogoCloudCarousel/LogoCloudCarousel";
import { LogoCloudGrid } from "../../../../modules/content/components/LogoCloudGrid/LogoCloudGrid";
import { GroundCommonContent } from "../../../../modules/content/components/GroundCommonContent/GroundCommonContent";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { ILogoCloudBlockProps } from "./LogoCloudBlock.props";

export const LogoCloudBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
  variant,
}: ILogoCloudBlockProps) => {
  if (!items?.length) return null;
  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8">
        <GroundCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {variant === "carousel" ? (
          <LogoCloudCarousel items={items} />
        ) : (
          <LogoCloudGrid items={items} />
        )}
      </div>
    </GroundSection>
  );
};

LogoCloudBlock.displayName = "Block::LogoCloudBlock";
